export var DEPLOY_DATE = new Date('2026-07-29T13:53:49+0000');
